import { Directive, OnChanges } from '@angular/core';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import { Collection } from '../../common/gql/graphql';

export type OfferCollection = Pick<Collection, 'name' | 'slug' | 'customFields'>;

@Directive()
export abstract class BaseOfferLabelComponent implements OnChanges {

    offerCollections: Array<{ name: string; description?: string; slug: string }> = [];
    isBlackFridayDeal = false;
    isJanuarySaleDeal = false;
    rrpDiscount: string | undefined;
    rrpDiscountQualifier = false;
    info = faInfo;

    ngOnChanges() {
        if (this.collections) {
            this.offerCollections = this.collections
                .filter((c) => c.customFields?.isOfferCollection === true)
                .map((c) => ({
                    name: c.customFields?.offerName ?? c.name,
                    description: c.customFields?.offerDescription ?? undefined,
                    slug: c.slug,
                }));
            if (this.collections.find((c) => c.customFields?.displayRrpDiscount === true)) {
                this.calculateRrpDiscount();
            }
            const isBlackFridayOffer = this.hasFacetValue('black-friday');
            const isJanuarySaleOffer = this.hasFacetValue('january-sale');
            if (isJanuarySaleOffer || isBlackFridayOffer) {
                if (!this.rrpDiscount) {
                    this.calculateRrpDiscount();
                }
            }
            this.isJanuarySaleDeal = isJanuarySaleOffer;
            this.isBlackFridayDeal = isBlackFridayOffer;
        }
    }

    /**
     * The collections to check if the entity is part of an offer collection.
     */
    abstract get collections(): OfferCollection[] | undefined;

    /**
     * Check if the entity has a specific facet value. For example, 'black-friday' or 'january-sale'.
     * @param facetValueCode
     * @protected
     */
    protected abstract hasFacetValue(facetValueCode: string): boolean;

    /**
     * Calculate the RRP discount that should be displayed for the entity.
     * @protected
     */
    protected abstract calculateRrpDiscount(): void;
}
